import { NavLink } from "react-router-dom";
import { getValue } from "@utils/lodash";

export default function LegalNavigation(props: any) {
  return (
    <div className="common-sticky-header">
      <section className="inner-page-navigation-with-back-cta-buttons position-relative">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <NavLink to="/repository/legal-update">
              <img
                src="/images/back-link.svg"
                className="img-fluid"
                height={24}
                width={24}
              />
            </NavLink>
            <div className="inner-page-navigation-with-back-cta-button__header">
              {/* <h4 className="inner-page-navigation-with-back-cta-button__header-title">
                Legal Update
              </h4> */}
            </div>
            <ul className="inner-page-navigation-with-back-cta-buttons__navigation d-inline-flex position-absolute">
              <li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
                <NavLink
                  to="#0"
                  className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
                >
                  Legal Details
                </NavLink>
              </li>
            </ul>
          </div>

          {getValue(props, `id`, "") ? (
            <div>
              <NavLink to={props.url}>
                <button className="ascent-button ascent-button--header-buttons ascent-button--primary mx-3">
                  Cancel
                </button>
              </NavLink>
              {props.isLoading ? (
                <button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
                  Please wait...
                </button>
              ) : (
                <button
                  className={`ascent-button ascent-button--header-buttons ascent-button--${
                    !props.isChanged ? "secondary" : "primary"
                  }`}
                  onClick={props.handleSubmit}
                  disabled={props.isChanged}
                >
                  Save
                </button>
              )}
            </div>
          ) : (
            <div>
              <NavLink to={props.url}>
                <button className="ascent-button ascent-button--header-buttons ascent-button--primary mx-3">
                  Cancel
                </button>
              </NavLink>
              {props.isLoading ? (
                <button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
                  Please wait...
                </button>
              ) : (
                <button
                  className={`ascent-button ascent-button--header-buttons ascent-button--${
                    !props.isChanged ? "secondary" : "primary"
                  }`}
                  onClick={props.handleSubmit}
                  disabled={props.isChanged}
                >
                  Save
                </button>
              )}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}